import React from "react";
import Footer from "../utils/Footer";
import GoTopButton from "../utils/GoTopButton";
import Header from "../utils/Header";
import StickyMenu from "../utils/StickyMenu";
const images = require.context("../../assets/img", true);

export const DefaultLayout = (props) => {
  return (
    <div
      className={
        "container-fluid px-0 d-flex flex-column justify-content-between position-relative " +
        props.className
      }
    >
      <Header />
      {props.noMenu ? <></> : <StickyMenu />}
      {props.children}
      <img
        className="img-fluid"
        src={images("./grayTrees.png")}
        alt="grayTrees"
      />
      <GoTopButton />
      <Footer />
    </div>
  );
};

export default DefaultLayout;
